<template>
  <div class="partner-bill-page">
    <el-tabs v-model="activeTab">
      <el-tab-pane label="维保记录" name="list">
        <service-list />
      </el-tab-pane>
      <el-tab-pane label="统计分析" name="stat" lazy>
        <bill-stat />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import serviceList from "./serviceList";
import billStat from "./stat/index";

export default {
  name: "partnerBillPage",
  components: { serviceList, billStat },
  data() {
    return {
      activeTab: "list"
    };
  }
};
</script>

<style scoped>
.partner-bill-page {
  padding: 0 10px;
}
</style>
